


<template>
  <v-app>
    <v-layout wrap >
      <v-flex >
    <v-main>
      <Header v-if="appType != 'User'" />
      <SellerHeader v-if="appType == 'User'"/>
       <router-view/>
      <Footer/>
    </v-main>
      </v-flex>
    </v-layout>
  </v-app>
</template>
<script>
import axios from "axios"
import "./assets/style/style.css";
import "./assets/style/font.css";
 import Header from './components/Common/header.vue';
  import SellerHeader from './components/Common/sellerHeader.vue';
  import Footer from './components/Common/footer.vue'
export default {
  name: 'App',

  components: {
     Header,
     Footer,
     SellerHeader,
  },
 computed:{
    appType() {
      console.log( this.$store.state.userRole)
      return this.$store.state.userRole;
    },
 },
  data: () => ({
    //
  }),
  beforeMount() {
    if (typeof localStorage.getItem("token") == "string") this.getUser();
  },
  methods:{
      getUser() {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("userData", response.data.data);
            this.$store.commit("changeCart", response.data.cart_length);
            // this.$store.commit("userType", response.data.data.user.role);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};
</script>
